import script from "./sidebar-dropdown.vue?vue&type=script&lang=js"
export * from "./sidebar-dropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/layouts/partials/sidebar-dropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20d01fc0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20d01fc0', __exports__)) {
    console.log('reload')
    api.reload('20d01fc0', __exports__)
  }
  
}


export default __exports__